import {Layout, Text, Avatar, Spacer} from '@di-nxt/components';
import React from 'react';
import {TeamMember} from '../../../services';

type Props = {
  member?: TeamMember;
};

const SideBarWidth = 260;

export const MemberSidebar: React.FC<Props> = ({member}) => {
  return (
    <Layout
      hideWhen={['mobile', 'tablet']}
      vertical
      width={SideBarWidth}
      align="center"
      paddingVertical="40"
      borderRightColor="border_mono_15"
      borderRightStyle="solid"
      borderRightWidth="1">
      <Avatar name={member?.fullname} uri={member?.avatarUrl} size="122" />
      <Spacer height="16" />
      <Text align="center" variant="inline_20_emphasis">
        {member?.display}
      </Text>
      <Spacer height="4" />
      <Text
        align="center"
        variant="inline_14_default">{`${member?.title} · ${member?.userId}`}</Text>
    </Layout>
  );
};
